import { api, ShareLinkEligibleProject } from '../../services/api';

/**
 * The eligible-projects list resolves every calibrated project server-side, so it is
 * slow. The project-page button warms it once a project checks out, and the create
 * dialog reuses it. Kept briefly so a freshly calibrated project still shows up soon.
 */
const TTL_MS = 2 * 60 * 1000;
let cached: { at: number; promise: Promise<ShareLinkEligibleProject[]> } | null = null;

export function loadEligibleProjects(): Promise<ShareLinkEligibleProject[]> {
  if (cached && Date.now() - cached.at < TTL_MS) return cached.promise;
  const promise = api.getShareLinkEligibleProjects('MAP_3D').then((res) => res.projects);
  const entry = { at: Date.now(), promise };
  cached = entry;
  promise.catch(() => { if (cached === entry) cached = null; });
  return promise;
}

// Per project for the session: the header button shows as soon as its own check lands.
const projectChecks = new Map<string, Promise<boolean>>();

export function isProjectShareable(projectId: string): Promise<boolean> {
  let check = projectChecks.get(projectId);
  if (!check) {
    check = api.getShareLinkProjectEligibility(projectId)
      .then((res) => res.eligible)
      // A backend without the per-project route yet: fall back to the (slow) full list.
      .catch(() => loadEligibleProjects().then((list) => list.some((p) => p.projectId === projectId)));
    projectChecks.set(projectId, check);
    check.catch(() => projectChecks.delete(projectId));
  }
  return check;
}
